import { fromEvent, of } from 'rxjs'
import {
  catchError,
  filter,
  switchMap
} from 'rxjs/operators'
import { ofType } from 'redux-observable'
import { fetchAnalytics } from 'api/planet/analytics'
import { initOneTrustScript } from 'config/oneTrust.ts'
import { ONE_TRUST_EVENT_NAME } from 'constants/oneTrust.ts'
import { getHaveOneTrustCookiesBeenSet } from 'domain/oneTrust.ts'
import { captureException } from 'helpers/raven'
import { isObject } from 'helpers/typeof'
import { getDeviceInfo } from 'helpers/useragent'
import * as Actions from 'store/actions/index.ts'
import {
  getCountryCode,
  getCultureCode,
  getIsOneTrustFeatureEnabled,
  getPartner
} from 'store/selectors'

// type IsAnalyticsFetchResponseValid = any => boolean
const isAnalyticsFetchResponseValid = analytics => (
  isObject(analytics) &&
  Boolean(analytics) && Boolean(analytics.trackers)
)

// type OnInvalidTrackingFetchResponse = (Error, boolean) => Observable<any> // Observable<AnalyticsErrorAction>
const onInvalidTrackingFetchResponse = (error, isSentryEnabled) => {
  if (isSentryEnabled) {
    captureException(
      new Error('Analytics error: Could not obtain tracking list'),
      { extra: { error } }
    )
  }

  return of(Actions.tracking.onAnalyticsError(error))
}

const fetchAnalyticAndConsentsEpic = (actions$, state$) => actions$.pipe(
  ofType(
    Actions.member.MEMBER_INFO_FETCHED
  ),
  switchMap(() => {
    const state = state$.value
    const i18nProperties = {
      Country: getCountryCode(state),
      Language: getCultureCode(state)
    }
    const partner = getPartner(state)

    return fetchAnalytics(i18nProperties, partner).pipe(
      switchMap(({ response }) => {
        if (!isAnalyticsFetchResponseValid(response)) {
          return onInvalidTrackingFetchResponse(new Error('Corrupted analytics'), false)
        }

        const trackers = response?.trackers
        const oneTrustToken = response?.consentManagement?.token
        const isWebview = getDeviceInfo().webview
        const shouldUseOneTrust = getIsOneTrustFeatureEnabled(state) && Boolean(oneTrustToken) && isWebview

        if (!shouldUseOneTrust) {
          return of(Actions.tracking.onInitTracking(trackers))
        }

        initOneTrustScript(oneTrustToken)

        return getHaveOneTrustCookiesBeenSet()
          ? of(Actions.tracking.onInitTracking(trackers))
          : fromEvent(window, ONE_TRUST_EVENT_NAME)
            .pipe(
              filter(() => getHaveOneTrustCookiesBeenSet()),
              switchMap(() => of(Actions.tracking.onInitTracking(trackers)))
            )
      }),
      catchError(error => onInvalidTrackingFetchResponse(error, true))
    )
  })
)

export default fetchAnalyticAndConsentsEpic
